import * as types from "../actions/actionTypes";
import { getAllOrderTimelineEventsResponse, getOrderTimelineEventByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const ordertimelineeventEntity = createEntitySagas({
  entity: "ordertimelineevent",
  endpoint: "order-timeline-events",
  label: "Timeline event",
  scope: "none",
  quiet: true,
  selectSlice: (state) => state.ordertimelineevent,
  listKey: "events",
  types: {
    getAll: types.GET_ALL_ORDER_TIMELINE_EVENTS,
    getById: types.GET_ORDER_TIMELINE_EVENT_BY_ID,
    create: types.CREATE_ORDER_TIMELINE_EVENT,
    update: types.UPDATE_ORDER_TIMELINE_EVENT,
    remove: types.DELETE_ORDER_TIMELINE_EVENT,
  },
  actions: { getAllResponse: getAllOrderTimelineEventsResponse, getByIdResponse: getOrderTimelineEventByIdResponse },
});

export const ordertimelineeventSaga = ordertimelineeventEntity.watcher;
